import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI } from '../Interface';

const LicenseFields = () => {
  const { values, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-3">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Licenc megnevezése" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="col-span-1">
        <Field
          type="number"
          name="qty"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Licenc mennyiség" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.qty} />}
          disabled
          InputLabelProps={{ shrink: Boolean(values.qty) }}
        />
      </div>
    </div>
  );
};

export default LicenseFields;
